import { z } from 'zod';

export const AccountCreditTransactionTypeSchema = z.enum([
  'REFUND_CANCELLATION',
  'MANUAL_COMPENSATION',
  'REFERRAL_BONUS',
  'MEMBERSHIP_TOP_UP',
  'MEMBERSHIP_EXPIRY',
  'BOOKING_USAGE',
]);

export const CreateManualCreditInputSchema = z.object({
  accountId: z.string().uuid(),
  amountInSmallestUnit: z.number().int().refine((amount) => amount !== 0, {
    message: 'Amount must not be zero',
  }),
  currency: z.string().trim().length(3).default('CZK'),
  reason: z.string().trim().min(3).max(500),
});

export const ListCreditTransactionsQuerySchema = z.object({
  accountId: z.string().uuid().optional(),
  type: AccountCreditTransactionTypeSchema.optional(),
  q: z.string().max(200).optional(),
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});

export type CreateManualCreditInput = z.infer<typeof CreateManualCreditInputSchema>;
export type ListCreditTransactionsQuery = z.infer<typeof ListCreditTransactionsQuerySchema>;
